<template lang="html">
    <div class="prebookOverlayHolder text-center d-flex justify-content-center align-items-center">
        <div class="d-flex flex-column w-100 mb-5">
            <h1 class="bold">This is not a final booking.</h1>
            <span class="fs-larger bold">
                If you can see this, please note that someone might be in the middle<br> of a purchase or maybe has given up.
            </span>
        </div>
    </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.prebookOverlayHolder{
    width: 100%;
    height: 550px;
}
</style>



// WEBPACK FOOTER //
// PrebookOverlay.vue?85955470